export interface MermaidFallbackRenderOptions {
  fontFamily?: string
  id?: string
  securityLevel?: 'strict' | 'loose' | 'antiscript' | 'sandbox'
  theme?: 'base' | 'dark' | 'default' | 'forest' | 'neutral'
  themeVariables?: Record<string, string | number>
}

export interface RenderMermaidSvgOptions {
  mermaid?: MermaidFallbackRenderOptions
}

export interface RenderMermaidSvgResult {
  bindFunctions?: (element: Element) => void
  renderer: 'mermaid'
  svg: string
}

let mermaidModule: Promise<typeof import('mermaid')> | null = null

const loadMermaid = async () => {
  if (!mermaidModule) {
    mermaidModule = import('mermaid')
  }

  return (await mermaidModule).default
}

export async function renderMermaidSvg(
  code: string,
  options: RenderMermaidSvgOptions = {}
): Promise<RenderMermaidSvgResult> {
  const normalizedCode = code.replace(/\\n/g, '\n')
  const mermaid = await loadMermaid()

  mermaid.initialize({
    fontFamily: options.mermaid?.fontFamily,
    securityLevel: options.mermaid?.securityLevel ?? 'strict',
    startOnLoad: false,
    theme: options.mermaid?.theme ?? 'default',
    themeVariables: options.mermaid?.themeVariables,
  })

  const { bindFunctions, svg } = await mermaid.render(
    options.mermaid?.id ?? `mermaid-${Math.random().toString(36).slice(2, 10)}`,
    normalizedCode
  )

  return {
    bindFunctions: bindFunctions ?? undefined,
    renderer: 'mermaid',
    svg,
  }
}
